/* eslint-disable react/prop-types */
import Space from 'Modules/Space';
import React from 'react';
import { Button } from 'semantic-ui-react';

import styles from './ParticipantItem.less';

const ParticipantItem = ({
  fullName,
  desc,
  avatarUrl,
  isMain,
  confirmSetMainProvider,
  isEligibleToSetMainProvider,
}) => {
  return (
    <Space
      direction="horizontal"
      size={12}
      className={styles.item}
      width="100%"
      alignItems="center"
      justify="space-between">
      <Space direction="horizontal" size={12}>
        <div
          className={styles.avatar}
          style={
            avatarUrl
              ? {
                  backgroundImage: `url(${avatarUrl})`,
                }
              : {}
          }
        />
        <Space size={4} justify="center">
          <Space direction="horizontal" size={12}>
            <div className={styles.name}>{fullName}</div>
            {isMain && <span className={styles.main}>Main</span>}
          </Space>
          <div className={styles.desc}>{desc}</div>
        </Space>
      </Space>
      {isEligibleToSetMainProvider && (
        <Button onClick={confirmSetMainProvider}>Set as Main Provider</Button>
      )}
    </Space>
  );
};

export default ParticipantItem;
